import { configureStore } from '@reduxjs/toolkit';
import { surveySlice } from './slices/survey/surveySlice';

export const store = configureStore({
    reducer: {
        survey: surveySlice.reducer,
    }
});